<template>
    <b-form-group class="c-checkbox-wrapper" :class="extraClasses">
        <div v-if="label?.length">
            <p>{{ label }}</p>
        </div>
        <b-form-checkbox
            v-model="model"
            v-b-tooltip.hover.left
            class="d-inline-block ignore-custom-control"
            :name="name"
            :switch="switchType"
            :disabled="disabled"
            :title="tooltip"
            @change="handleClick"
        >
            {{ computedCheckboxLabel }}
        </b-form-checkbox>
        <b-form-text v-if="!!$slots.default">
            <slot />
        </b-form-text>
    </b-form-group>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Model, Prop } from 'vue-property-decorator';

@Component({ name: 'CustomCheckbox' })
export default class CustomCheckbox extends Vue {
    @Model('input', { type: Boolean }) readonly value!: boolean;
    @Prop({ default: '' }) readonly name!: string;
    @Prop(String) readonly label!: string;
    @Prop(String) readonly checkboxLabel!: string;
    @Prop(String) readonly tooltip?: string;
    @Prop({ default: 'Yes' }) enableText!: string;
    @Prop({ default: 'No' }) disabledText!: string;
    @Prop({ default: false }) readonly switchType!: boolean;
    @Prop({ default: false }) readonly disabled!: boolean;
    @Prop({ default: false }) readonly hideLabel!: boolean;
    @Prop(String) readonly extraClasses!: string;

    get computedCheckboxLabel(): string {
        if (this.switchType && !this.checkboxLabel?.length) {
            return this.value ? this.enableText : this.disabledText;
        }
        return this.hideLabel ? '' : this.checkboxLabel;
    }

    get model(): boolean {
        return this.value;
    }

    set model(value) {
        if (value == this.model) return;
        this.$emit('input', value);
    }

    handleClick(event: MouseEvent) {
        this.$emit('click-checkbox', { event, value: this.value });
    }
}
</script>
